var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
import { fetchReferralCodes } from '@/lib/db/DBReferralHelpers';
import { fetchReferrals, getReferrer } from '@/lib/db/DBReferralCodesHelpers';
import { fetchDBCloudWallet } from '@/lib/db/DBCloudWalletHelpers';
export var useUserCloudQuery = function (PKP) {
    var _a = useLocalStorage('cloudUserData', null), userCloudDataLC = _a[0], setUserCloudDataLC = _a[1];
    var query = useQuery({
        queryKey: ['cloudUserData'],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, dataToReturn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress))
                            return [2 /*return*/, null];
                        return [4 /*yield*/, fetchDBCloudWallet()];
                    case 1:
                        data = _a.sent();
                        dataToReturn = data.data ? data : null;
                        setUserCloudDataLC(dataToReturn);
                        return [2 /*return*/, dataToReturn];
                }
            });
        }); },
        enabled: PKP && (PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) ? true : false, // Only fetch if ethAddress exists
        staleTime: 1000 * 60 * 5, // Cache for 5 minutes
        refetchOnWindowFocus: false,
    });
    return __assign(__assign({}, query), { data: userCloudDataLC || query.data, isLoading: !userCloudDataLC && query.isLoading });
};
// Fetch referral codes and referrals
export var useReferralQuery = function (PKP, cloudData) {
    var _a;
    var _b = useLocalStorage('referralData', null), referralDataLC = _b[0], setReferralDataLC = _b[1];
    var query = useQuery({
        queryKey: ['referrals', { codes: null, referrals: null }],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var referralCodesPromise, referrerPromise, _a, referralCodes, referrer, codes, referrals, totalReferralVolume, allReferrals, totalReferralVolumePayload, error_1;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) || !((_b = cloudData.data) === null || _b === void 0 ? void 0 : _b.user_id))
                            return [2 /*return*/, null];
                        return [4 /*yield*/, fetchReferralCodes({
                                ethAddress: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
                            })];
                    case 1:
                        referralCodesPromise = _g.sent();
                        return [4 /*yield*/, getReferrer()];
                    case 2:
                        referrerPromise = _g.sent();
                        return [4 /*yield*/, Promise.all([referralCodesPromise, referrerPromise])];
                    case 3:
                        _a = _g.sent(), referralCodes = _a[0], referrer = _a[1];
                        codes = referralCodes.data && Array.isArray(referralCodes.data) && referralCodes.data.length > 0
                            ? referralCodes.data[0]
                            : null;
                        referrals = null;
                        totalReferralVolume = null;
                        _g.label = 4;
                    case 4:
                        _g.trys.push([4, 8, , 9]);
                        return [4 /*yield*/, fetchReferrals({ refererUserId: (_c = cloudData === null || cloudData === void 0 ? void 0 : cloudData.data) === null || _c === void 0 ? void 0 : _c.user_id })];
                    case 5:
                        allReferrals = _g.sent();
                        return [4 /*yield*/, fetch('/api/referrals/status?code=' + (codes === null || codes === void 0 ? void 0 : codes.referral_code))];
                    case 6:
                        totalReferralVolumePayload = _g.sent();
                        return [4 /*yield*/, totalReferralVolumePayload.json()];
                    case 7:
                        totalReferralVolume = (_d = (_g.sent())) === null || _d === void 0 ? void 0 : _d.orderValue;
                        referrals =
                            allReferrals && allReferrals.data && allReferrals.data.length > 0
                                ? allReferrals.data
                                : null;
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _g.sent();
                        console.error('Failed to fetch referrals:', error_1);
                        return [3 /*break*/, 9];
                    case 9:
                        setReferralDataLC({
                            codes: codes,
                            referrals: referrals,
                            referrer: ((_e = referrer.data) === null || _e === void 0 ? void 0 : _e.eth_address) ? referrer.data : null,
                            totalReferralVolume: totalReferralVolume,
                        });
                        return [2 /*return*/, {
                                codes: codes,
                                referrals: referrals,
                                totalReferralVolume: totalReferralVolume,
                                refferer: ((_f = referrer.data) === null || _f === void 0 ? void 0 : _f.eth_address) ? referrer.data : null,
                            }];
                }
            });
        }); },
        enabled: PKP && cloudData && cloudData.data && !!(PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress) && !!((_a = cloudData.data) === null || _a === void 0 ? void 0 : _a.user_id)
            ? true
            : false,
        staleTime: 1000 * 60 * 5, // Cache for 5 minutes
        refetchOnWindowFocus: false,
    });
    return __assign(__assign({}, query), { data: referralDataLC || query.data, isLoading: !referralDataLC && query.isLoading });
};
